import styled from "styled-components";

export default styled.div`
  margin: 0 auto;
  display: flex;
  width: 143px;
  height: 45px;

  & > button {
    padding: 12px 0;
    font-size: 16px;
  }
`;
